// extracted by mini-css-extract-plugin
export var askAiIcon = "_od-j";
export var category = "_od-9";
export var categoryHeader = "_od-e";
export var container = "_od-0";
export var group = "_od-a";
export var groupItems = "_od-f";
export var groupSeparator = "_od-k";
export var loading = "_od-1";
export var noResults = "_od-3";
export var placeholder = "_od-2";
export var resultContent = "_od-5";
export var resultIcon = "_od-c";
export var resultItem = "_od-g";
export var resultMeta = "_od-8";
export var resultSubtitle = "_od-7";
export var resultSuffix = "_od-i";
export var resultTitle = "_od-6";
export var resultsList = "_od-4";
export var searchGroup = "_od-d";
export var selected = "_od-h";
export var subgroup = "_od-b";